// extracted by mini-css-extract-plugin
module.exports = {"nav":"SubSections_nav__sNk6I","link":"SubSections_link__mZmR9","unselected":"SubSections_unselected__Vxjb_","list":"SubSections_list__Axfbu"};